import { render, staticRenderFns } from "./LecturePurchased.vue?vue&type=template&id=2bb691f0&"
import script from "./LecturePurchased.vue?vue&type=script&lang=js&"
export * from "./LecturePurchased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports